module.exports = __webpack_public_path__ + "static/media/cu05_ch02.b0d30dbf.png";